import {useCallback, useMemo} from 'react';
import cx from 'classnames';
import {EditorIcon} from '~/CreateFabricInvitation/routes/EventCreateDesign/components/EditorIcons/EditorIcon';
import {AssetIconType} from '~/common/types/assets_icons';

import './EditorIcons.sass';

interface EditorIconsProps {
  icons?: AssetIconType[];
  onClick?: (icon: AssetIconType, id?: string | number | null) => void;
  selectedIcon?: AssetIconType;
  height?: number;
  width?: number;
  className?: string;
  hideAnimatedIndicator?: boolean;
  flipEnvelope?: (shouldFlip: boolean | null) => void;
  showEnvelopeFront?: boolean | null;
  circle?: boolean;
  noPadding?: boolean;
  outline?: boolean;
}

const getIconId = (icon?: AssetIconType): string => {
  if (typeof icon === 'object') {
    return icon.id || 'none';
  }
  return icon || 'none';
};

export const EditorIcons = ({
  icons = [],
  onClick,
  selectedIcon,
  height,
  width,
  className,
  hideAnimatedIndicator,
  flipEnvelope,
  showEnvelopeFront,
  circle,
  noPadding = false,
  outline = false,
}: EditorIconsProps) => {
  const onClickHandler = useCallback(
    (icon: AssetIconType, id: string | number) => {
      if (onClick) {
        onClick(icon, id);
      }
    },
    [onClick]
  );

  const iconsMemo = useMemo(
    () =>
      icons?.map((icon: AssetIconType) => {
        const iconId = getIconId(icon);
        const selectedIconId = getIconId(selectedIcon);

        return (
          <EditorIcon
            key={iconId}
            icon={icon}
            onClick={onClickHandler}
            isActive={Boolean(selectedIconId && iconId && selectedIconId === iconId)}
            height={height}
            width={width}
            hideAnimatedIndicator={hideAnimatedIndicator}
            flipEnvelope={flipEnvelope}
            showEnvelopeFront={showEnvelopeFront}
            circle={circle}
            outline={outline}
          />
        );
      }),
    [
      icons,
      onClickHandler,
      selectedIcon,
      height,
      width,
      hideAnimatedIndicator,
      flipEnvelope,
      showEnvelopeFront,
      circle,
      outline,
    ]
  );

  return (
    <div className={cx('editor-icons', className, {'editor-icons--no-padding': noPadding})}>
      {iconsMemo}
    </div>
  );
};
